module.exports = __webpack_public_path__ + "img/rudi.52516917.png";